import { render, staticRenderFns } from "./CreateBusinessUnitModalWizzard.vue?vue&type=template&id=0a80d744&scoped=true&"
import script from "./CreateBusinessUnitModalWizzard.vue?vue&type=script&lang=js&"
export * from "./CreateBusinessUnitModalWizzard.vue?vue&type=script&lang=js&"
import style0 from "./CreateBusinessUnitModalWizzard.vue?vue&type=style&index=0&id=0a80d744&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80d744",
  null
  
)

export default component.exports